import { PropsWithChildren } from 'react';
import ReactDom from 'react-dom';

export const ModalPortal = ({ children }: PropsWithChildren) => {
  return ReactDom.createPortal(
    children,
    document.getElementById('modal-root') as HTMLElement
  );
};
